var _polygon, _polygon2, _circle, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBioverseaiLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 40",
    width: 200,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#4299e1",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#9f7aea",
      stopOpacity: 1
    }
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "18,4 30,11 30,25 18,32 6,25 6,11",
    fill: "url(#grad)",
    opacity: 0.9
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "18,8 26,13 26,23 18,28 10,23 10,13",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.2,
    opacity: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 3.5,
    fill: "#fff",
    opacity: 0.9
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 24,
    fontFamily: "'Segoe UI', Arial, sans-serif",
    fontSize: 16,
    fontWeight: 700,
    fill: "url(#grad)"
  }, "bioverseAI")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBioverseaiLogo);
export default __webpack_public_path__ + "static/media/bioverseai-logo.90d463be2e3afd615b2228fb7ac53fdc.svg";
export { ForwardRef as ReactComponent };